export default {
    namespaced: true,
    state: {
        usuario: null,  
        isAutenticado: false,        
    },
    getters: {
        getUsuario(state) {
            return state.usuario;
        },      
        getIsAutenticado(state) {
            return state.isAutenticado;
        },      
    },
    mutations: {
        setUsuario(state, usuario) {
            state.usuario = usuario;
        },      
        setIsAutenticado(state, autenticado) {
            state.isAutenticado = autenticado;
        }                
    },
    actions: {
        criarSessao(context, dados) {   
            context.commit('setUsuario', {
                id: dados.id,
                nome: dados.nome,
                cpf: dados.cpf,
                pis: dados.pis,
                grupo: dados.grupo,
                numeroCnpj: dados.numeroCnpj,
                permissoes: dados.permissoes
            });           
            context.commit('setIsAutenticado', true);
        },
        limparSessao(context) {
            sessionStorage.clear();
            localStorage.clear();
            context.commit('setUsuario', null);   
            context.commit('setIsAutenticado', false);            
        },            
    }
}